// extracted by mini-css-extract-plugin
module.exports = {"newsItem":"RssFeed_newsItem__2LlFp","newsTitle":"RssFeed_newsTitle__2dxZN","timestamp":"RssFeed_timestamp__2WtwX"};